import { SOMETHING_WENT_WRONG } from '@nykaa/my-profile-shared/constants';
import {
  VerifyMappingOtpError,
  VerifyMappingOtpResponse,
  VerifyMappingOtpStatus,
} from 'User/types/emailVerification';
import { standardErrorMessages } from 'shared/constants';
import { statusMessages } from 'shared/constants/statusCodes';
import {
  VERIFY_MAPPING_OTP_API_ERROR,
  prefixForEmailVeriErrorLogs,
} from 'User/store/emailVerification/constants/errorMessages';

export const transformVerifyMappingOtp = (
  error: null | Error,
  apiResponse: any
): VerifyMappingOtpResponse => {
  if (error) {
    /**
     * HANDLE NETWORK ERROR
     * In this case we prompt the user that some Network error has happened
     */
    return {
      error: {
        type: VerifyMappingOtpError.NETWORK_ERROR,
        errorToLog: `${error.response?.status} ${prefixForEmailVeriErrorLogs.NETWORK_ERROR}: ${VERIFY_MAPPING_OTP_API_ERROR}`,
        messageToDisplay:
          error?.response?.data?.message || SOMETHING_WENT_WRONG, // GENERIC NETWORK ERROR MESSAGE
      },
    };
  }

  const { status } = apiResponse;

  if (status === statusMessages.SUCCESS) {
    return {
      status: VerifyMappingOtpStatus.SUCCESS,
    };
  }

  /**
   * The following case handles
   * Authentication failed
   * Fraud-list
   * OTP Verification failed
   * Verify Attempts exhausted
   */
  const {
    message,
    // editingAllowed,
    retryLeft: verifyExceeded,
  } = apiResponse;

  let errorType = VerifyMappingOtpError.OTHER;
  let prefixForErrorToLog = '';
  if (verifyExceeded) {
    errorType = VerifyMappingOtpError.EXHAUSTED_VERIFY_ATTEMPTS;
    prefixForErrorToLog = prefixForEmailVeriErrorLogs.RETRIES_EXHAUSTED;
  }
  if (status === 'fail') {
    // Failed to verify OTP
    errorType = VerifyMappingOtpError.VERIFICATION_FAILED;
    prefixForErrorToLog = prefixForEmailVeriErrorLogs.OTP_VERIFICATION_FAILED;
  }

  return {
    error: {
      type: errorType,
      messageToDisplay: message || standardErrorMessages.SOMETHING_WRONG,
      errorToLog: `${prefixForErrorToLog}:${VERIFY_MAPPING_OTP_API_ERROR}`,
    },
  };
};
